import axios from 'axios';
import { getSessionToken } from './sessionTokenService';

const searchApi = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/v1`,
  timeout: 15000,
});

// Add request interceptor for session token
searchApi.interceptors.request.use(
  (config) => {
    const sessionToken = getSessionToken();
    if (sessionToken) {
      config.headers['X-Session-Token'] = sessionToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export interface SearchResult {
  ticker: string;
  name: string;
}

export interface SearchResponse {
  success: boolean;
  message: string;
  data: {
    results: SearchResult[];
    status: string;
    search_term: string;
    count: number;
  };
  metadata: {
    queryDate: string;
    searchTerm: string;
    resultCount: number;
  };
}

export interface MarketStatusResponse {
  success: boolean;
  message: string;
  data: {
    market_status: 'open' | 'pre-market' | 'after-hours' | 'closed';
    last_updated: string;
    market_open_timestamp: string | null;
    market_close_timestamp: string | null;
    market_pre_market_timestamp: string | null;
  };
}

export const searchApiService = {
  async searchTickers(searchTerm: string): Promise<SearchResponse> {
    try {
      const response = await searchApi.get(`/data-processor/search?q=${encodeURIComponent(searchTerm)}`);
      return response.data;
    } catch (error) {
      console.error('Search API error:', error);
      throw error;
    }
  },

  async getMarketStatus(): Promise<MarketStatusResponse> {
    try {
      const response = await searchApi.get('/market-status');
      return response.data;
    } catch (error) {
      console.error('Market status API error:', error);
      throw error;
    }
  },
};

export default searchApiService;
